import * as Yup from "yup";

export const myProfileValidationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  phone_number: Yup.string().required("Phone number is required"),
  office_phone_number: Yup.string().required("Office phone number is required"),
  contact_preference: Yup.string().required("Contact preference is required"),
  profile_pic_url: Yup.string(),
});

export const myProfileFields = [
  // {
  //   name: "email",
  //   label: "Email",
  //   type: "email",
  //   placeholder: "Enter email",
  // },
  {
    name: "first_name",
    label: "First Name",
    type: "text",
    placeholder: "Enter first name",
  },
  {
    name: "last_name",
    label: "Last Name",
    type: "text",
    placeholder: "Enter last name",
  },
  {
    name: "phone_number",
    label: "Phone Number",
    type: "tel",
    placeholder: "Enter phone number",
  },
  {
    name: "office_phone_number",
    label: "Office Phone Number",
    type: "tel",
    placeholder: "Enter office phone number",
  },
  {
    name: "contact_preference",
    label: "Contact Preference",
    type: "select",
    options: [
      { value: "Mobile_Phone", label: "Mobile Phone" },
      { value: "Office_Phone", label: "Office Phone" },
    ],
  },
];
